import { AnalyticsService } from './analytics-service';

export const analyticsService = new AnalyticsService();
